import type { ComponentProps } from 'react';
import { TextField } from './text-field';

type NumberFieldProps = Omit<ComponentProps<typeof TextField>, 'type' | 'inputMode'> & {
  readonly integer?: boolean;
};

export function NumberField({ integer, ...props }: NumberFieldProps) {
  return <TextField {...props} inputMode={integer ? 'numeric' : 'decimal'} />;
}
